module.exports = __webpack_public_path__ + "static/img/login_title.e6e2ce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/login_title.png
// module id = kynm
// module chunks = 57